import { useEffect, useState } from "react";
import { useLang } from "../services/lang";

export function When({ date }: { date: string }) {
    const { lang, dict } = useLang();
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) {
        return <span className="date-placeholder">...</span>;
    }

    const d = new Date(date);
    const year = d.getFullYear();
    const month = dict.monthCalendar[d.getMonth()];
    const day = d.getDate();
    const dayOfWeek = dict.daysOfWeek[d.getDay()];

    const hours = d.getHours();
    const minutes = d.getMinutes();

    let dateDay = `${dayOfWeek} ${day}. ${month} ${year}`;
    switch (lang) {
        case "cs": dateDay = `${dayOfWeek} ${day}. ${month} ${year}`; break;
        case "en": dateDay = `${dayOfWeek}, ${month} ${day}, ${year}`; break;
        case "es": dateDay = `${dayOfWeek}, ${day} de ${month} de ${year}`; break;
    }

    if (date.length === 10 || (hours === 0 && minutes === 0)) {
        return <>{dateDay}</>;
    } else {
        if (lang === "en") {
            let displayHour = hours % 12;
            if (displayHour === 0) displayHour = 12;

            return <>{`${dateDay}, ${displayHour}:${minutes.toFixed(0).padStart(2, "0")} ${hours >= 12 ? 'PM' : 'AM'}`}</>;
        } else {
            return <>{`${dateDay}, ${hours}:${minutes.toFixed(0).padStart(2, "0")}`}</>;
        }
    }
}
